module.exports = __webpack_public_path__ + "img/location-nl.6e08c65c.svg";